import { FC } from 'react';

import { InputBaseWithOptions } from './Input.type';
import { OptionFieldsGroup } from './atoms/OptionFieldsGroup';

type Props = InputBaseWithOptions<string[]>;

export const InputCheckbox: FC<Props> = (props) => <OptionFieldsGroup {...props} type="checkbox" />;
